import React from "react";
import "./styles.css";

const unwrapHttpUrl = (value) => {
  const url = String(value || "").trim();
  const markdownMatch = url.match(/^\[[^\]]*\]\((https?:\/\/.+)\)$/i);
  const normalizedUrl = markdownMatch?.[1] || url;

  return /^https?:\/\//i.test(normalizedUrl) ? normalizedUrl : "";
};

const formatDistance = (distance, isKilometers) => {
  if (distance == null || distance === "") return "";

  const value = Number(distance);
  if (!Number.isFinite(value)) return "";

  if (isKilometers) {
    return `${value.toFixed(1).replace(/\.0$/, "")}km`;
  }

  return value >= 1000 ? `${(value / 1000).toFixed(1)}km` : `${value}m`;
};

const HotelCard = ({ hotel }) => {
  if (!hotel) return null;

  const isLegacy = Boolean(hotel.hotel_data);
  const d = isLegacy ? hotel.hotel_data : hotel;
  const detail = d.Detail || {};
  const name = isLegacy
    ? d.hotelName || detail.HotelName || ""
    : d.name || "";
  const photo = unwrapHttpUrl(
    isLegacy ? d.headPicture || detail.ThumbNailUrl : d.firstPicture,
  );
  const score = isLegacy
    ? d.commentScore || detail.Review?.Score || ""
    : "";
  const commentCount = isLegacy
    ? d.commentCount || detail.Review?.Count || ""
    : "";
  const star = isLegacy ? d.starName || detail.StarRateTxt || "" : "";
  const address = isLegacy
    ? d.hotelAddress || detail.Address || ""
    : d.address || "";
  const price = isLegacy
    ? d.lowPrice || d.LowRate || ""
    : (d.priceValue ?? d.price ?? "");
  const distance = formatDistance(
    isLegacy ? d.distance_number : d.distanceKm,
    !isLegacy,
  );
  const url = unwrapHttpUrl(
    isLegacy
      ? d.redirectPcUrl || d.redirectUrl
      : d.urlInfo?.PC || d.urlInfo?.h5,
  );
  const summary = isLegacy ? d.summary || "" : d.description || "";

  const shortSummary = summary
    ? summary.replace(/【优点】/, "").split("【缺点】")[0].slice(0, 100) + "..."
    : "";
  const CardContainer = url ? "a" : "div";
  const linkProps = url
    ? { href: url, target: "_blank", rel: "noopener noreferrer" }
    : {};

  return (
    <CardContainer className="hotel-card-item" {...linkProps}>
      {photo && (
        <div className="hotel-card-img">
          <img src={photo} alt={name} />
          {star && <span className="hotel-card-star">{star}</span>}
        </div>
      )}
      <div className="hotel-card-info">
        <div className="hotel-card-name">{name}</div>
        <div className="hotel-card-meta">
          {score && (
            <span className="hotel-card-score">
              {score}分
              {commentCount && <span className="hotel-card-count"> ({commentCount}条评价)</span>}
            </span>
          )}
          {distance && <span className="hotel-card-distance">{distance}</span>}
        </div>
        {address && <div className="hotel-card-addr">{address}</div>}
        {shortSummary && <div className="hotel-card-summary">{shortSummary}</div>}
        <div className="hotel-card-bottom">
          {price !== "" && (
            <span className="hotel-card-price">
              ¥<strong>{price}</strong>
              <span className="hotel-card-price-unit">起</span>
            </span>
          )}
          <span className="hotel-card-book">查看详情 →</span>
        </div>
      </div>
    </CardContainer>
  );
};

const HotelCardList = ({ hotels }) => {
  if (!hotels || hotels.length === 0) return null;

  return (
    <div className="hotel-card-list">
      {hotels.map((hotel, idx) => (
        <HotelCard
          key={hotel?.hotel_data?.HotelId || hotel?.hotelId || idx}
          hotel={hotel}
        />
      ))}
    </div>
  );
};

export default HotelCardList;
